import { newToolFilterOAuthMcp } from "../oauth.ts";

export const circlebackMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://circleback.ai/apple-touch-icon.png",
  url: "https://circleback.ai/api/mcp",
  label: "Circleback",
});
